/**
 * Auth Redirect Handler Route
 *
 * OAuth callback endpoint for MSAL redirect handling.
 * Microsoft redirects here after authentication, and MsalWrapper's
 * handleRedirectPromise() processes the auth code from the URL.
 *
 * IMPORTANT: Keep this page passive. MSAL handles redirect parsing.
 *
 * Route Configuration:
 * - Path: /auth-redirect
 * - Public: isSecured: false (no auth required)
 */

import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth-redirect')({
  staticData: {
    title: 'Authenticating...',
    isSecured: false,
  },
  component: AuthRedirectPage,
})

function AuthRedirectPage() {
  // This page should be completely passive
  // MSAL in the parent window monitors this popup's URL
  // and will extract the auth code and close the popup automatically
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        <div className="text-gray-600">Completing sign in...</div>
      </div>
    </div>
  )
}
